// resources/js/utils/ContractParser.js

/**
 * A simplified, modular class for parsing contract addresses from message text
 * and identifying their general type (EVM or Solana).
 */
export class ContractParser {
    /**
     * Finds all potential contract addresses in a given text and identifies their type.
     * @param {string} messageText - The text of the message to parse.
     * @returns {Array<{address: string, type: 'evm' | 'solana'}>} An array of found contract objects.
     */
    static parse(messageText) {
        if (!messageText || typeof messageText !== 'string') {
            return [];
        }

        const contracts = [];
        
        // Regex for EVM addresses (0x followed by 40 hex characters)
        const evmRegex = /0x[a-fA-F0-9]{40}/g;
        const evmMatches = messageText.match(evmRegex) || [];
        for (const address of evmMatches) {
            contracts.push({ address: address.toLowerCase(), type: 'evm' });
        }

        // Regex for Solana addresses (Base58, typically 32-44 characters long)
        // This is a heuristic, but good enough for initial parsing.
        const solanaRegex = /(?<![a-zA-Z0-9])[1-9A-HJ-NP-Za-km-z]{32,44}(?![a-zA-Z0-9])/g; // <-- MORE SPECIFIC REGEX
        const solanaMatches = messageText.match(solanaRegex) || [];
        for (const address of solanaMatches) {
            // Avoid matching EVM addresses which might be caught by a loose Base58 regex
            // and ensure it's not just a long number or random string.
            if (!evmMatches.includes(address) && isNaN(address)) {
                contracts.push({ address, type: 'solana' });
            }
        }

        return contracts;
    }
}